import { Injectable } from "@angular/core";

export interface ICustomDocument extends Document {
  mozCancelFullScreen: any;
  webkitExitFullscreen: any;
  msExitFullscreen: any;
}

@Injectable({ providedIn: "root" })
export class GlobalService {
  get nativeWindow(): Window {
    return window;
  }
  get nativeDocument(): ICustomDocument {
    return document as Document & {
      mozCancelFullScreen: any;
      webkitExitFullscreen: any;
      msExitFullscreen: any;
    };
  }
}
